export const NOSH_AUTH_DATA_KEY = 'NOSH_AUTH_DATA_KEY';
